<template>
    <div class="container">
        <h4 style="margin-top:0">Individuelle Interaction hinzufügen</h4>
        <div class="button-row">
            <inputFloatLabel style="width: 48%" label="Interaction-Name" @input="nameChanged"
                             value=""></inputFloatLabel>
            <TemplateInput style="width: 48%" label="Technischer Name" @onRealValueChanged="technicalNameChanged"
                           :extension-text="this.selectedStandardInteraction ? this.selectedStandardInteraction.technical_name : ''"
                           :value="technicalName"></TemplateInput>
        </div>
        <div class="button-row">
            <Checkbox id="onDesktop" class="checkbox" v-model="onDesktop" title="Desktop"></Checkbox>
            <Checkbox id="onMobile" class="checkbox" v-model="onMobile" title="Mobile"></Checkbox>
            <Checkbox id="onTablet" class="checkbox" v-model="onTablet" title="Tablet"></Checkbox>
        </div>
        <div class="select-container">
            <div>
                Interaction-Typ wählen:
            </div>
            <div class="checkbox-container">
                <Checkbox :rounded="true" class="checkbox" v-for="int in standardInteractions" v-bind:key="int.id"
                          :id="'' + int.id"
                          @change="interactionSelectionChanged(int.id)" v-model="int.selected"
                          :title="int.technical_name"></Checkbox>
            </div>
        </div>
        <inputFloatLabel style="margin-bottom: 10px;margin-top: 10px" label="Beschreibung" @input="descChanged"
                         :value="description"></inputFloatLabel>
        <AdaButton :loading="savingTemplate" title="INTERACTION HINZUFÜGEN" type="createButton" @click="createClicked" style="width:fit-content"></AdaButton>
    </div>
</template>

<script>
    import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import Checkbox from "../../../components/inputs/Checkbox";
    import TemplateInput from "../../../components/inputs/TemplateInput";
    import AdaButton from "../../../components/buttons/AdaButton";

    const InteractionsRepository = RepositoryFactory.get('interactions');

    export default {
        components: {
            InputFloatLabel,
            TemplateInput,
            Checkbox,
            AdaButton
        },
        data: function () {
            return {
                interactionName: '',
                technicalName: '',
                standardInteractions: [],
                selectedStandardInteraction: null,
                description: '',
                onDesktop: true,
                onMobile: true,
                onTablet: true,
                savingTemplate: false,
            }
        },
        name: "CreateInteractionTemplateDialog",
        mounted() {
            this.fetchStandardInteractions();
        },
        methods: {
            descChanged(val) {
                this.description = val;
            },
            nameChanged(val) {
                this.interactionName = val;
            },
            technicalNameChanged(val) {
                this.technicalName = val;
            },
            async fetchStandardInteractions() {
                try {
                    const {data} = await InteractionsRepository.getStandardInteractions();
                    data.forEach(int => {
                        int.selected = false;
                    });
                    this.standardInteractions = data;
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler bei der Abfrage der Standard Interactions. => " + e.message);
                }
            },
            interactionSelectionChanged(id) {
                this.selectedStandardInteraction = null;
                this.technicalName = '';
                this.standardInteractions.forEach(int => {
                    if (int.id !== id) {
                        int.selected = false;
                    } else if (int.selected) {
                        this.selectedStandardInteraction = int;
                        this.technicalName = int.name;
                    }
                })
            },
            async createClicked() {
                this.savingTemplate = true;
                if (this.technicalName[0] !== '_') {
                    this.$noty.error('Der technische Name muss mit "_" anfangen.');
                    this.savingTemplate = false;
                    return;
                }
                try {
                    await InteractionsRepository.createInteraction({
                        is_standard: 0,
                        is_template: 1,
                        name: this.interactionName,
                        technical_name: this.technicalName,
                        description: this.description,
                        on_desktop: this.onDesktop,
                        on_mobile: this.onMobile,
                        on_tablet: this.onTablet
                    });
                    this.$noty.success("Neue Interaction Vorlage erfolgreich erstellt!");
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler bei der Erstellung: " + e);
                }
                this.savingTemplate = false;
            },
            toggleDevice: function () {
                switch (this.interactionType.toLowerCase()) {
                    case 'online':
                        this.interactionType = 'alle';
                        break;
                    case 'alle':
                        this.interactionType = 'online';
                        break;
                }
            },
            deviceInput: function () {
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        width: 700px;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .button-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .checkbox-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
        max-height: 300px;
        overflow-y: scroll;
    }

    .checkbox {
        width: 30%;
        justify-content: start;
        margin: 9px;
        padding: 2px 0;
        overflow: auto;
    }

    ::v-deep .pretty .state label:before,
    ::v-deep .pretty .state label:after{
        top: calc((0% - (100% - 20px)) - 8%) !important;
    }
</style>